$(document).ready(function () {
    newsletterSignup();
});

// Newsletter singup form
function newsletterSignup() {
    $('#newsletter-form').on('submit', function (e) {
        e.preventDefault();

        let name = $('input[name="name"]', $(this)).val();
        let mail = $('input[name="mail"]', $(this)).val();
        let g_recaptcha_response_newsletter = $('input[name="g-recaptcha-response-newsletter"]', $(this)).val();
        let consent = $('input[name="consent"]', $(this)).is(':checked');

        $('.formElement').removeClass('error');
        $('#newsletter-form-body').find(".alert").remove();

        if (!consent) {
            $('#newsletter-form-body').append('<div class="alert mb-2 alert-danger alert-dismissible fade show" role="alert">' + $('input[name="consent-message"]', $(this)).val() + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
            return false;
        }

        $.ajax({
            type: 'POST',
            url: 'ajax/mailchimp',
            data: {
                name: name,
                mail: mail,
                g_recaptcha_response_newsletter: g_recaptcha_response_newsletter
            }
        }).done(function (feedback) {
            let alertClass;
            if (feedback.hasOwnProperty('error') && feedback.error === 1) {
                alertClass = 'danger';
            } else {
                $('#newsletter-form').hide();
                alertClass = 'success';
            }
            $('#newsletter-form-body').append('<div class="alert mb-2 alert-' + alertClass + ' alert-dismissible fade show" role="alert">' + feedback.message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
        });
    });
}
